import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { selectAvailableCountryOptions } from "@redux";
import { FullWidthInputWrapper, HalfWidthInputWrapper, StepperFormRow } from "@components";

export const ClientAdress = ({ control }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientAddress)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <SelectFormField
          control={control}
          name="clientAddress.0.data.addressCountry"
          title={trb(i18.Labels.AddressCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.0.data.addressCity"
          title={trb(i18.Labels.AddressCity)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.0.data.addressStreet"
          title={trb(i18.Labels.AddressStreet)}
        />
      </HalfWidthInputWrapper>

      <HalfWidthInputWrapper>
        <InputFormField
          control={control}
          name="clientAddress.0.data.addressPostCode"
          title={trb(i18.Labels.AddressPostCode)}
        />
      </HalfWidthInputWrapper>
    </StepperFormRow>
  );
};
